export const languageOptions = [
    { value: "en", label: "English" },
    { value: "de", label: "Deutsch" },
    { value: "fr", label: "français" },
    { value: "es", label: "español" },
]

export default languageOptions